import './core-hop';

import {mixin as arrayUtils} from './services/array-utils';
import {mixin as dateFormatter} from './services/date-format';
import {mixin as httpClient} from './services/http-client';
import {mixin as storage} from './services/storage';

const Hop = window.Hop;

Hop.support = Hop.support || {};
Hop.supportFn = Hop.supportFn || {};

const testDraganddrop = function () {
    const div = document.createElement('div');
    return 'draggable' in div || ('ondragstart' in div && 'ondrop' in div);
};

Hop.support.draganddrop = testDraganddrop();

/* test-code */
Hop._test = {};
/* end-test-code */

if ($('html').hasClass('csstransitions')) {
    jQuery.fx.off = true;
}

arrayUtils(Hop);
storage(Hop);
httpClient(Hop);

dateFormatter(Hop);

Hop.hasFormValidation = function () {
    return 'noValidate' in document.createElement('form');
};

function getLang() {
    const htmlLang = $('html').attr('lang') || 'en';
    const langs = ['br', 'cn', 'cz', 'de', 'ee', 'en', 'es', 'fa', 'fi', 'fr', 'hu', 'id', 'it', 'lt', 'nl', 'pl', 'pt', 'ro', 'ru', 'si', 'ua'];

    const lang = htmlLang.match(/\D\D/);

    if (lang === null || $.inArray(lang[0], langs) === -1) {
        return 'en';
    } else {
        return lang[0];
    }
}

Hop.getLang = getLang;

$(() => {
    Hop.oldscrollTop = null;

    $('.modal')
        .on('show.bs.modal', function () {
            // $('body').css({"padding-right": ''});
            $('html').addClass('modal-open-for-html');

            // eslint-disable-next-line no-invalid-this
            const el = this;

            Hop.control.init(el);

            if (el.querySelectorAll('.lazy').length && typeof window.Echo === 'object') {
                window.Echo.render(true);
            }
        })
        .on('hidden.bs.modal', function () {
            $('html').removeClass('modal-open-for-html');

            if ($('.modal.in').length) {
                $('html').addClass('modal-open-for-html');
                $('body').addClass('modal-open');
            }

            // eslint-disable-next-line no-invalid-this
            const el = this;

            Hop.control.destroy(el);
        });

    Hop.control.init();

    if (window.location.hash !== '') {
        const oMenu = Hop.getStoreObj('menu');
        if (oMenu) {
            $(oMenu.root).on('stickyopen', () => {
                $(oMenu.root).off('stickyopen');
                let $elReferencedByHash;
                try {
                    $elReferencedByHash = $(window.location.hash);
                } catch (e) {
                    if (e.toString().indexOf('unrecognized expression') === -1) {
                        throw e;
                    }
                    // else swallow it, we can't do anything about invalid hashes here, especially when entered by users
                }
                if ($elReferencedByHash && $elReferencedByHash.length) {
                    $('html, body').animate(
                        {
                            scrollTop: $elReferencedByHash.offset().top - oMenu.hmenu,
                        },
                        500,
                    );
                }
            });
        }
    }
});
